import React from 'react';
import { Handle, Position, useReactFlow } from 'reactflow';
import ConfirmDialog from '../overlays/ConfirmDialog';

function ListNode({ id, data, selected }) {
    const { setNodes, setEdges, getNode } = useReactFlow();
    const [showDelete, setShowDelete] = React.useState(false);
    const map   = data.map || {};
    const items = map.items || map.sections?.flatMap(s => s.rows || []) || [];

    const confirmDelete = () => {
        setShowDelete(false);
        setNodes(n => n.filter(x => x.id !== id));
        setEdges(e => e.filter(x => x.source !== id && x.target !== id));
    };
    const handleDuplicate = (e) => {
        e.stopPropagation();
        const node = getNode(id);
        if (!node) return;
        setNodes(n => [...n, { ...node, id:`node_${Date.now()}`, position:{ x:node.position.x+30, y:node.position.y+30 }, selected:false }]);
    };

    return (
        <div style={{ width:200, background:'#fff', border:`2px solid ${selected ? '#7c3aed' : '#e5e7eb'}`, borderRadius:10, boxShadow:'0 2px 8px rgba(0,0,0,0.08)', overflow:'hidden' }}>
            <div style={{ display:'flex', alignItems:'center', justifyContent:'space-between', padding:'7px 10px', background:'linear-gradient(to right, #7c3aed, #6d28d9)' }}>
                <div style={{ display:'flex', alignItems:'center', gap:6, color:'#fff', fontSize:11, fontWeight:700 }}>
                    <i className="bi bi-list-ul" style={{ fontSize:12 }}></i> List Menu
                </div>
                <div style={{ display:'flex', gap:4 }}>
                    <button onClick={handleDuplicate} style={btnStyle}><i className="bi bi-copy" style={{ fontSize:10 }}></i></button>
                    <button onClick={e => { e.stopPropagation(); setShowDelete(true); }} style={btnStyle}><i className="bi bi-x" style={{ fontSize:12 }}></i></button>
                </div>
            </div>
            <div style={{ padding:'8px 10px' }}>
                {map.question && <p style={{ fontSize:11, color:'#374151', fontWeight:500, lineHeight:1.4, margin:'0 0 6px', overflow:'hidden', display:'-webkit-box', WebkitLineClamp:2, WebkitBoxOrient:'vertical' }}>{map.question}</p>}
                <div style={{ display:'flex', flexDirection:'column', gap:3 }}>
                    {items.slice(0, 3).map((item, i) => (
                        <div key={i} style={{ display:'flex', alignItems:'center', gap:6, padding:'3px 6px', background:'#f5f3ff', borderRadius:6 }}>
                            <span style={{ fontSize:9, width:16, height:16, borderRadius:'50%', background:'#7c3aed', color:'#fff', fontWeight:700, display:'flex', alignItems:'center', justifyContent:'center', flexShrink:0 }}>{i+1}</span>
                            <span style={{ fontSize:10, color:'#374151', overflow:'hidden', textOverflow:'ellipsis', whiteSpace:'nowrap' }}>{item.label || item.title || `Option ${i+1}`}</span>
                        </div>
                    ))}
                    {items.length > 3 && <p style={{ fontSize:10, color:'#9ca3af', margin:'2px 0 0', textAlign:'center' }}>+{items.length-3} more</p>}
                </div>
                {map.variable && <p style={{ fontSize:10, color:'#9ca3af', fontFamily:'monospace', marginTop:4, marginBottom:0 }}>→ {map.variable}</p>}
            </div>
            <Handle id="a" type="target" position={Position.Left} style={hs}/>
            {items.length > 0
                ? items.map((item, i) => (
                    <Handle key={i} id={`opt_${item.id||i}`} type="source" position={Position.Right}
                        style={{ ...hs, top:`${((i+1)/(items.length+1))*100}%` }}/>
                ))
                : <Handle id="b" type="source" position={Position.Right} style={hs}/>
            }
            {showDelete && <ConfirmDialog message="Delete this node?" onConfirm={confirmDelete} onCancel={() => setShowDelete(false)}/>}
        </div>
    );
}

const btnStyle = { background:'none', border:'none', cursor:'pointer', color:'rgba(255,255,255,0.8)', padding:2, display:'flex', alignItems:'center' };
const hs = { width:10, height:10, background:'#7c3aed', border:'2px solid #fff', borderRadius:'50%' };

export default ListNode;
